export const categories = [
  {
    id: "sanduiches-naturais",
    title: "Sanduíches Naturais",
    subtitle: "9 sabores irresistíveis",
    description: "Preparados diariamente com ingredientes selecionados e muito sabor.",
    image: "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/18bb73e3-908b-461f-952a-054470d2e185_compressed_WhatsApp-Image-2026-07-13-at-12.06.10.webp",
    cta: "Ver Sanduíches",
    href: "#catalogo",
  },
  {
    id: "mini-pasteis",
    title: "Mini Pastéis",
    subtitle: "Crocantes e deliciosos",
    description: "Pacotes com 100 unidades, perfeitos para eventos e revenda.",
    image: "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/7d4bf5de-f9aa-45c7-a1de-f7d5572bd999_compressed_WhatsApp-Image-2026-07-17-at-16.08.10.webp",
    cta: "Ver Mini Pastéis",
    href: "#catalogo",
  },
  {
    id: "eventos",
    title: "Eventos",
    subtitle: "Soluções completas",
    description: "Cardápios personalizados para empresas, escolas, universidades e eventos.",
    image: "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/f2abef0b-a46c-4748-afbb-755f987785a4_compressed_eventos-bigmania.webp",
    cta: "Solicitar Orçamento",
    href: "#eventos",
  },
  {
    id: "empresas",
    title: "Para Empresas",
    subtitle: "Atacado e revenda",
    description: "Abasteça seu negócio com produtos de qualidade e entrega confiável.",
    image: "https://storage.readdy-site.link/project_files/e2268d4a-73e3-4367-9d65-df24b53a0559/1d4fdddf-684e-4a45-8ecb-aa89d9b2e9dc_compressed_WhatsApp-Image-2026-07-13-at-12.16.55.webp",
    cta: "Seja um Revendedor",
    href: "#empresas",
  },
];